import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  align-self: center;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding-top: 2rem;
  }
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;

  & > * {
    width: 45%;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    & > * {
      width: auto;
    }
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  gap: 6px;
  margin-top: -35px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    margin-top: 0;
  }
`;

export const ActionsButtonsWrapper = styled.div`
  display: flex;
  align-items: left;
  gap: 5px;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  border: none;
  box-shadow: none;
  & > * {
    width: 100%;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;

export const CountWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const CourseWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
